import { Injectable } from "@angular/core";
import { SocketIoService } from "@ep-om/core/services/socket-io.service";
import { AuthUserService } from "../auth/authUser.service";
import { AnagraficaApparatoService } from "../state/anagraficaApparati/anagraficaApparato.service";
import { AnagraficaServiziService } from "../state/anagraficaServizi/anagraficaServizi.service";
import { AppointmentService } from "../state/appointment/appointment.service";
import { ArticoloPortaleOloService } from "../state/articoloPortaleOlo/articoloPortaleOlo.service";
import { GlobalBatchActivityService, ProjectBatchActivityService, UserBatchActivityService } from "../state/batchActivity/batchActivity.service";
import { CommentService } from "../state/comment/comment.service";
import { CompanyService } from "../state/company/company.service";
import { ConfermaAppuntamentoService } from "../state/confermaAppuntamento/confermaAppuntamento.service";
import { EntityInteractionService } from "../state/entityInteraction/entityInteraction.service";
import { IIDEspletatoOkChecklistGISFOService } from "../state/espletatoOkChecklistGISFO/espletatoOkChecklistGISFO.service";
import { IIDApparatoSplitterService } from "../state/iidApparatoSplitter/iidApparatoSplitter.service";
import { IIDassuranceTicketService } from "../state/iidAssuranceTicket/iidAssuranceTicket.service";
import { IIDChecklistGISFOService } from "../state/iidChecklistGISFO/iidChecklistGISFO.service";
import { IIDConnectionRequestService } from "../state/iidConnectionRequest/iidConnectionRequest.service";
import { IIDepAssetsService } from "../state/iidEPAssets/iidEPAssets.service";
import { IIDepGisfoSupportService } from "../state/iidEPGisfoSupport/iidEPGisfoSupport.service";
import { IIDEpRichiestaService } from "../state/iidEPRichiestaPermesso/iidEPRIchiesta.service";
import { IIDEpRispostaService } from "../state/iidEPRisposta/iidEPRisposta.service";
import { IIDepTicketService } from "../state/iidEPTicket/iidEpTicket.service";
import { IIDFaultManagementService } from "../state/iidFaultManagement/iidFaultManagement.service";
import { IIDFeasabilityAssociationService } from "../state/iidFeasabilityAssociation/iidFeasabilityAssociation.service";
import { IIDFeasabilityResponseService } from "../state/iidFeasabilityResponse/iidFeasabilityResponse.service";
import { IID_Generic_AppointmentService } from "../state/iidGenericAppointment/genericAppointment.service";
import { IID_Generic_KoService } from "../state/iidGenericKo/genericKo.service";
import { IID_Generic_OkService } from "../state/iidGenericOk/genericOk.service";
import { IIDgenericSuspensionService } from "../state/iidGenericSuspension/genericSuspension.service";
import { IIDGisfoWorkorderService } from "../state/iidGisfoWorkorder/iidGisfoWorkorder.service";
import { IIDGrResourcesService } from "../state/iidGRResources/iidGRResources.service";
import { IIDGrTasksService } from "../state/iidGRTasks/iidGRTasks.service";
import { IIDIssueLinkService } from "../state/iidIssueLink/iidIssueLink.service";
import { IIDIssueLinkedService } from "../state/iidIssueLinked/iidIssueLinked.service";
import { IIDMailGtwService } from "../state/iidMailGtw/iidMailGtw.service";
import { IIDNetworkItemsService } from "../state/iidNetworkItems/iidNetworkItems.service";
import { IIDolAcquisitiKoService } from "../state/iidOlAcquisitiKo/acquisitiKo.service";
import { IIDolActivationRequestService } from "../state/iidOlActivationRequest/iidOlActivationRequest.service";
import { IIDolAnnullatoService } from "../state/iidOlAnnullato/annulato.service";
import { IIDolApparatoService } from "../state/iidOlApparato/iidOlApparato.service";
import { IIDolAppuntamentoService } from "../state/iidOlAppuntamento/iidOlAppuntamento.service";
import { IIDolChecklistService } from "../state/iidOlChecklist/iidOlChecklist.service";
import { IIDolClienteService } from "../state/iidOlCliente/iidOlCliente.service";
import { IIDolCommunicationService } from "../state/iidOlCommunication/iidOlCommunication.service";
import { IIDolCondominioService } from "../state/iidOlCondominio/iidOlCondominio.service";
import { IIDolContrattoService } from "../state/iidOlContratto/iidOlContratto.service";
import { IIDolDeactivationService } from "../state/iidOlDeactivation/iidOlDeactivation.service";
import { IIDolDeactivationPhysicService } from "../state/iidOlDeactivationPhysic/iidOlDeactivationPhysic.service";
import { IIDolDeactivationValidationService } from "../state/iidOlDeactivationValidation/iidOlDeactivationValidation.service";
import { IIDolEspletatoKoService } from "../state/iidOlEspletatoKo/espletatoKo.service";
import { IIDolEspletatoOkService } from "../state/iidOlEspletatoOk/espletatoOk.service";
import { IIDolEspletatoOkOFService } from "../state/iidOlEspletatoOkOF/espletatoOkOF.service";
import { IIDolAccettatoKoService } from "../state/iidOloAccettatoKo/accettatoKo.service";
import { IIDolOloRequestService } from "../state/iidOlOloRequest/iidOlOloRequest.service";
import { IIDolOloRequestOFService } from "../state/iidOlOloRequestOF/iidOlOloRequestOF.service";
import { IIDolRiferimentiService } from "../state/iidOlRiferimenti/iidOlRiferimenti.service";
import { IIDolRiferimentiUiService } from "../state/iidOlRiferimentiUi/iidOlRiferimentiUi.service";
import { IIDolRisoluzioneService } from "../state/iidOlRisoluzione/iidOlRisoluzione.service";
import { IIDolRisorsaService } from "../state/iidOlRisorsa/iidOlRisorsa.service";
import { IIDolRisorsaPniService } from "../state/iidOlRisorsaPni/iidOlRisorsaPni.service";
import { IIDolRispostaSollecitoService } from "../state/iidOlRispostaSollecito/iidOlRispostaSollecito.service";
import { IIDolServizioAggiuntivoService } from "../state/iidOlServizioAggiuntivo/iidOlServizioAggiuntivo.service";
import { IIDolSollecitoService } from "../state/iidOlSollecito/iidOlSollecito.service";
import { IIDolSospensioneService } from "../state/iidOlSospensione/iidOlSospensione.service";
import { IIDolSupportoService } from "../state/iidOlSupporto/iidOlSupporto.service";
import { IIDolVlanService } from "../state/iidOlVlan/iidOlVlan.service";
import { IIDPortaleContrattiService } from "../state/iidPortaleContratti/iidPortaleContratti.service";
import { IIDPraticaIruCustomerService } from "../state/iidPraticaIruCustomer/iidPraticaIruCustomer.service";
import { IIDPraticaIruProviderService } from "../state/iidPraticaIruProvider/iidPraticaIruProvider.service";
import { IIDRisorsaLORAService } from "../state/iidRisorsaLORA/iidRisorsaLORA.service";
import { IIDRisorseCreationService } from "../state/iidRisorseCreation/iidRisorseCreation.service";
import { IIDRisorseIruAcquisizioneService } from "../state/iidRisorseIruAcquisizione/iidRisorseIruAcquisizione.service";
import { IIDRisorsePermessoPubblicoService } from "../state/iidRisorsePermessoPubblico/iidRisorsePermessoPubblico.service";
import { IIDSLAEditorService } from "../state/iidSLAEditor/iidSLAEditor.service";
import { IssueService } from "../state/issue/issue.service";
import { IssueStateService } from "../state/issueState/issueState.service";
import { IssueStateWorkflowService } from "../state/issueStateWorkflow/issueStateWorkflow.service";
import { IssueTypeService } from "../state/issueType/issueType.service";
import { IssueTypeInterfaceService } from "../state/issueTypeInterface/issueTypeInterface.service";
import { IssueTypeWorkflowService } from "../state/issueTypeWorkflow/issueTypeWorkflow.service";
import { KeyvalueService } from "../state/keyvalue/keyvalue.service";
import { MetainterfacesService } from "../state/metaInterfaces/metaInterfaces.service";
import { MilestoneService } from "../state/milestone/milestone.service";
import { ProjectService } from "../state/project/project.service";
import { ProjectCategoryService } from "../state/projectCategory/projectCategory.service";
import { ProjectScopeService } from "../state/projectScope/projectScope.service";
import { ResourceService } from "../state/resource/resource.service";
import { ResourceItemService } from "../state/resourceItem/resourceItem.service";
import { RisorseVerificaService } from "../state/risorseVerifica/risorseVerifica.service";
import { SharedResourceService } from "../state/sharedResource/sharedResource.service";
import { StudioFattibilitaRequestService } from "../state/studioFattibilitaRequest/studioFattibilitaRequest.service";
import { TagService } from "../state/tag/tag.service";
import { TaskTypeCategoryService } from "../state/taskTypeCategory/taskTypeCategory.service";
import { UserService } from "../state/user/user.service";
import { WorkflowService } from "../state/workflow/workflow.service";
import { SysMessageService } from "./sysMessage.service";

import { IIDUnlockCodeService } from "../state/iidUnlockCode/iidUnlockCode.service";

@Injectable({ providedIn: 'root' })
export class EntityInitializerService {
  constructor(
    private socketService: SocketIoService,
    private authUserService: AuthUserService,
    private metaInterfaces: MetainterfacesService,
    private userService: UserService,
    private companyService: CompanyService,
    private projectService: ProjectService,
    private projectCategoryService: ProjectCategoryService,
    private projectScopeService: ProjectScopeService,
    private sysMessageService: SysMessageService,
    private workflowService: WorkflowService,
    private issueTypeService: IssueTypeService,
    private issueStateService: IssueStateService,
    private issueStateWorkflowService: IssueStateWorkflowService,
    private issueTypeWorkflowService: IssueTypeWorkflowService,
    private issueTypeInterfaceService: IssueTypeInterfaceService,
    private issueService: IssueService,
    private commentService: CommentService,
    private pActivityService: ProjectBatchActivityService,
    private gActivityService: GlobalBatchActivityService,
    private uActivityService: UserBatchActivityService,
    private entityInteractionService: EntityInteractionService,
    private appointmentService: AppointmentService,
    private taskTypeCategoryService: TaskTypeCategoryService,
    private articoloPortaleOloService: ArticoloPortaleOloService,
    private anagraficaServiziService: AnagraficaServiziService,
    private anagraficaApparatoService: AnagraficaApparatoService,
    //tags
    private tagService: TagService,
    //interface services
    private iidOloCommunicationService: IIDolCommunicationService,
    private iidOloRequestService: IIDolOloRequestService,
    private iidOloClienteService: IIDolClienteService,
    private iidOloContrattoService: IIDolContrattoService,
    private iidOloRiferimentiService: IIDolRiferimentiService,
    private iidOloCondominioService: IIDolCondominioService,
    private iidOloServizioAggiuntivoService: IIDolServizioAggiuntivoService,
    private iidOloApparatoService: IIDolApparatoService,
    private iidApparatoSplitterService: IIDApparatoSplitterService,
    private iidOloChecklistService: IIDolChecklistService,
    private iidOloAppuntamentoService: IIDolAppuntamentoService,
    private iidOloAcquisitiService: IIDolAcquisitiKoService,
    private iidOloAccettatoService: IIDolAccettatoKoService,
    private iidOloEspletatoOkService: IIDolEspletatoOkService,
    private iidOloEspletatoKoService: IIDolEspletatoKoService,
    private iidOloAnnullatoService: IIDolAnnullatoService,
    private iidOloEpAssetsService: IIDepAssetsService,
    private iidOloSospensione: IIDolSospensioneService,
    private iidOlSupporto: IIDolSupportoService,
    private iidOlRisorsa: IIDolRisorsaService,
    private iidOlRiferimentiUi: IIDolRiferimentiUiService,
    private iidGenericOkService: IID_Generic_OkService,
    private iidGenericKoService: IID_Generic_KoService,
    private iidGenericSuspensionService: IIDgenericSuspensionService,
    private iidOlActivationRequestService: IIDolActivationRequestService,
    private iidOlVlanService: IIDolVlanService,
    private iidEpRichiestaService: IIDEpRichiestaService,
    private iidOlSollecitoService: IIDolSollecitoService,
    private iidOlRispostaSollecitoService: IIDolRispostaSollecitoService,
    private iidOlRisoluzioneService: IIDolRisoluzioneService,
    private iidOlDeactivationService: IIDolDeactivationService,
    private iidOlDeactivationValidationService: IIDolDeactivationValidationService,
    private iidOlDeactivationPhysicService: IIDolDeactivationPhysicService,
    private iidMailGtwService: IIDMailGtwService,
    private iidAssuranceTicketService: IIDassuranceTicketService,
    private iidNetworkItemsService: IIDNetworkItemsService,
    private iidFaultManagementService: IIDFaultManagementService,
    private iid_Generic_AppointmentService: IID_Generic_AppointmentService,
    private iidRisorsaLORAService: IIDRisorsaLORAService,
    private iidChecklistGISFOService: IIDChecklistGISFOService,
    private iidEspletatoOkChecklistGISFOService: IIDEspletatoOkChecklistGISFOService,
    private epTicketService: IIDepTicketService,
    private milestoneService: MilestoneService,
    private iidGrTasksService: IIDGrTasksService,
    private iidGrResourcesService: IIDGrResourcesService,
    private iidEpGisfoSupportService: IIDepGisfoSupportService,
    private keyvalueService: KeyvalueService,
    private resourceService: ResourceService,
    private resourceItemService: ResourceItemService,
    private iidEpRispostaService: IIDEpRispostaService,
    private iidRisorsaPniService: IIDolRisorsaPniService,
    private iidOlEspletatoOkOFService: IIDolEspletatoOkOFService,
    private iidOlOloRequestOFService: IIDolOloRequestOFService,
    private iidIssueLinkService: IIDIssueLinkService,
    private iidIssueLinkedService: IIDIssueLinkedService,
    private iidSLAEditorService: IIDSLAEditorService,
    private iidPortaleContrattiService: IIDPortaleContrattiService,
    private confermaAppuntamentoService: ConfermaAppuntamentoService,
    private iidPraticaIruCustomerService: IIDPraticaIruCustomerService,
    private iidPraticaIruProviderService: IIDPraticaIruProviderService,
    private iidRisorseCreationService: IIDRisorseCreationService,
    private risorseVerificaService: RisorseVerificaService,
    private iidRisorsePermessoPubblicoService: IIDRisorsePermessoPubblicoService,
    private iidRisorseIruAcquisizioneService: IIDRisorseIruAcquisizioneService,
    private iidGisfoWorkorderService: IIDGisfoWorkorderService,
    private iidConnectionRequestService: IIDConnectionRequestService,
    private iidFeasabilityResponseService: IIDFeasabilityResponseService,
    private studioFattibilitaRequestService: StudioFattibilitaRequestService,
    private iidFeasabilityAssociationService: IIDFeasabilityAssociationService,
    private sharedResourceService: SharedResourceService,
    private iidUnlockCodeService: IIDUnlockCodeService,
  ) { }
}
